/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-11 12:09:02
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-11-04 16:45:42
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/tools.ts
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { getLastModified, getLoaded, getPageName } from './slice';
import {
  timeoutScroll,
  generateErrorKey,
  reduxUpdatedStatusControl,
} from 'src/tools/helper';
import _ from 'lodash';
import {
  EnumIds,
  EnumCollapseId,
  collapseOpen,
  convertProductDetailArrToMap,
  convertProductDetailMapToArr,
} from 'src/pages/ProductEditor/VirtualProduct/common';
import { EnumProductType } from 'src/types/common/product';
import { checkAdvancedPrice } from 'src/pages/ProductEditor/tools/commonDataCheck';
//import { checkQuantityAndLeftValid } from 'src/pages/ProductEditor/tools/commonDataCheck';
import {
  //EnumProductType,
  EnumStatus,
} from 'src/types/common/product';
import {
  generateSalesChannelAvailableQuantity,
  convertSalesChannelAvailableQuantityToSalesChannelQuotas,
} from 'src/pages/ProductEditor/tools/common';
import { randomNumber, isNumber } from 'src/tools/helper';
import { generateDefaultDenomination } from './common';
import { buildGroupedPriceSettings } from 'src/tools/helper';

const getProductName = () => {
  const lastModified = useSelector(getLastModified());
  const { loaded } = useSelector(getLoaded());
  const _name = useSelector(getPageName());
  const name = React.useMemo(() => {
    return _name;
  }, [lastModified, loaded]);
  return name;
};

const validateProductInfo = ({ data }) => {
  const _data = _.cloneDeep(data || {});
  const { name, sku } = _data;
  let scrollId;
  if (!name) {
    _data[generateErrorKey('name')] = true;
    scrollId = EnumIds.productDetailTitle;
  }
  if (!sku) {
    _data[generateErrorKey('sku')] = true;
    scrollId = EnumIds.productInfoProductName;
  }
  return { hasError: scrollId, data: _data, scrollId };
};

const validateProductDetail = ({ data, orderId }) => {
  const _data = _.cloneDeep(data || {});
  const { title } = _data;
  let scrollId;
  if (!title) {
    _data[generateErrorKey('title')] = true;
    if (!scrollId) {
      //timeoutScroll(`${EnumIds.productDetailTitle}${orderId}`);
      scrollId = `${EnumIds.productDetailTitle}${orderId}`;
    }
  }
  return { data: _data, hasError: scrollId, scrollId };
};

const validateDenominations = ({ data }) => {
  const { denominations = [] } = data;
  const oriLength = denominations.length;
  const uniqLength = _.uniq(denominations).length;
  return { data: data, hasError: oriLength !== uniqLength };
};

const validatePricingSetting = ({ data }) => {
  const _data = _.cloneDeep(data || {});
  // const { defaultSalePrice } = _data;

  let scrollId;
  // if (!defaultSalePrice) {
  //   _data[generateErrorKey('defaultSalePrice')] = true;
  //   if (!scrollId) {
  //     //timeoutScroll(`${EnumIds.productDetailTitle}${orderId}`);
  //     scrollId = `${EnumIds.productDefaultPrice}`;
  //   }
  // }
  return { data: _data, hasError: scrollId, scrollId };
};

const validateAdvancedPricingSetting = ({ data }) => {
  const _data = _.cloneDeep(data || []);
  const { flag, data: nData } = checkAdvancedPrice(_data);
  const scrollId = flag ? EnumIds.productAdvancedPriceSettingTable : undefined;
  return { data: nData, hasError: scrollId, scrollId };
};

const validateAvailableQuantity = ({
  stock,
  // salesChannelAvailableQuantity,
  isService,
}) => {
  const _data = _.cloneDeep(stock || {});
  const { stockAvailableUnlimited, stockAvailable } = stock;
  if (stockAvailableUnlimited) {
    return { hasError: false };
  }
  const valid = isNumber(stockAvailable);

  if (!valid) {
    _data[generateErrorKey('stockAvailable')] = true;
  }
  // console.log('stockAvailable', stockAvailable);
  // console.log('salesChannelAvailableQuantity', salesChannelAvailableQuantity);
  // console.log(valid);
  return {
    hasError: !valid,
    scrollId: EnumCollapseId.Quantity,
    data: _data,
  };
};

const validation = ({ state, furtherStatus }) => {
  const {
    productType,
    productInfo,
    priceSettings,
    stock,
    productDenominations,
    advancedPriceSettings,
    // salesChannelAvailableQuantity,
    serviceDetails,
    serviceDetailsOrder,
    status,
  } = state;

  const _status = furtherStatus || status;
  const isActive = _status === EnumStatus.Active;
  const isService = productType === EnumProductType.Service;
  const isCard = productType === EnumProductType.GiftCard;

  const productInfoCheck = validateProductInfo({ data: productInfo });
  if (productInfoCheck.hasError) {
    const { data, scrollId } = productInfoCheck;
    state.dataValid = false;
    state.productInfo = data;
    state.collapseOpen[EnumCollapseId.ProductInfo] = true;
    timeoutScroll(scrollId);
    return;
  }

  if (isService && isActive) {
    for (const i of serviceDetailsOrder) {
      const productDetailCheck = validateProductDetail({
        data: serviceDetails[i],
        orderId: i,
      });
      if (productDetailCheck.hasError) {
        const { data, scrollId } = productDetailCheck;
        state.serviceDetails[i] = data;
        state.dataValid = false;
        state.collapseOpen[EnumCollapseId.ProductDetail] = true;
        timeoutScroll(scrollId);
        return;
      }
      continue;
    }
  }

  if (isActive && isCard) {
    const denominationsCheck = validateDenominations({
      data: productDenominations,
    });
    if (denominationsCheck.hasError) {
      const { hasError } = denominationsCheck;
      if (hasError) {
        state.dataValid = false;
        state.collapseOpen[EnumCollapseId.Denomination] = true;
        timeoutScroll(EnumCollapseId.Denomination);
        return;
      }
    }
  }

  if (isService && isActive) {
    const pricingCheck = validatePricingSetting({ data: priceSettings });
    if (pricingCheck.hasError) {
      const { data, scrollId } = pricingCheck;
      state.dataValid = false;
      state.priceSettings = data;
      state.collapseOpen[EnumCollapseId.Pricing] = true;
      timeoutScroll(scrollId);

      return;
    }
  }

  if (isService && isActive) {
    const check = validateAdvancedPricingSetting({
      data: advancedPriceSettings,
    });
    if (check.hasError) {
      const { data, scrollId } = check;
      state.dataValid = false;
      state.advancedPriceSettings = data;
      state.collapseOpen[EnumCollapseId.Pricing] = true;
      state.collapseOpen[EnumCollapseId['sub-advancedPriceSettingsOpen']] =
        true;
      timeoutScroll(scrollId);
      return;
    }
  }

  if (validateAvailableQuantity && isActive) {
    const check = validateAvailableQuantity({
      stock,
      // salesChannelAvailableQuantity,
      isService,
    });

    if (check.hasError) {
      const { scrollId, data } = check;
      state.dataValid = false;
      state.stock = data;
      state.collapseOpen[EnumCollapseId.Quantity] = true;
      // state.collapseOpen[EnumCollapseId['sub-salesChannelAvailableQuantity']] =
      //   true;
      timeoutScroll(scrollId);
      return;
    }
  }

  state.dataValid = true;
  return;
};

const convertDataFromReduxToServer = (data) => {
  const _data = _.cloneDeep(data);

  const {
    uuid,
    storeUuid,
    productType,
    thumbnailImage,
    productDenominations,
    priceSettings,
    salesChannelAvailableQuantity,
    advancedPriceSettings,
    productInfo,
    tags: _tags,
    stock,
    serviceDetails: _serviceDetails,
    serviceDetailsOrder,
    status,
    salesChannelUsageUuids,

    // productGiftCardSetting,
  } = _data;
  const { defaultSalePrice, cost, defaultRrp, localPrices } = priceSettings;
  const { tags } = _tags;
  const { name, remarks, codes, description, brand, sku } = productInfo;
  const salesChannelQuotas =
    convertSalesChannelAvailableQuantityToSalesChannelQuotas(
      salesChannelAvailableQuantity,
    );
  const virtualProductPriceSettings = advancedPriceSettings;
  const { stockAvailable, stockAvailableUnlimited, stockQuantity } = stock;
  const serviceDetails = convertProductDetailMapToArr({
    order: serviceDetailsOrder,
    map: _serviceDetails,
  });
  const productService = { serviceDetails };
  const _r = {
    uuid,
    storeUuid,
    productType,
    thumbnailImage,
    productDenominations,
    defaultSalePrice,
    defaultRrp,
    localPrices,
    tags,
    name,
    remarks,
    codes,
    description,
    brand,
    salesChannelQuotas,
    virtualProductPriceSettings,
    stockAvailable,
    stockAvailableUnlimited,
    stockQuantity,
    productService,
    status,
    sku,
    cost,
    salesChannelUsageUuids,

    //productGiftCardSetting,
  };
  return _r;
};

const convertProductFromServerToRedux = (product, priceTiers) => {
  if (product) {
    const {
      sku,
      tags = [],
      uuid,
      storeUuid,
      productType,
      thumbnailImage,
      defaultSalePrice,
      defaultRrp,
      localPrices,
      virtualProductPriceSettings = [], //advancedPriceSettings
      salesChannelQuotas = [], //salesChannelAvailableQuantity
      name,
      remarks,
      codes = [],
      description,
      brand = {},
      stockAvailable,
      stockAvailableUnlimited,
      stockQuantity,
      productDenominations = generateDefaultDenomination(),
      productService,
      modifiedDate: lastModified,
      stockSold,
      //  productGiftCardSetting,
      status,
      cost,
      salesChannelUsageUuids,
      hasBeenSold,
    } = product;

    const { serviceDetails: _serviceDetails } = productService || {};

    const { data: serviceDetails = {}, order: serviceDetailsOrder = {} } =
      convertProductDetailArrToMap(_serviceDetails || []);

    const _advancedPriceSettings = virtualProductPriceSettings.map((i) => {
      return { ...i, key: randomNumber() };
    });
    const advancedPriceSettingsInUuid = _advancedPriceSettings.map(
      (i) => i.priceTierUuid,
    );
    const yetTiers = (priceTiers || []).filter(
      (i) => !advancedPriceSettingsInUuid.includes(i.uuid),
    );
    const advancedPriceSettingsRaw = [
      ..._advancedPriceSettings,
      ...yetTiers.map((i) => {
        const { uuid, ...rest } = i;
        return { ...rest, key: randomNumber(), priceTierUuid: uuid };
      }),
    ];
    // console.log(salesChannelQuotas);
    // console.log(generateSalesChannelAvailableQuantity(salesChannelQuotas));

    const titleGroupMap = new Map();

    advancedPriceSettingsRaw.forEach((item) => {
      const { title } = item;
      if (!titleGroupMap.has(title)) {
        titleGroupMap.set(title, []);
      }
      titleGroupMap.get(title).push(item);
    });

    let mainIndex = 1;
    const advancedPriceSettings = [];

    for (const [, items] of titleGroupMap.entries()) {
      (items || []).forEach((item, idx) => {
        item.displayIndex = `${mainIndex}-${idx + 1}`;
        advancedPriceSettings.push(item);
      });
      mainIndex++;
    }

    const _r = {
      productType,
      uuid,
      storeUuid,
      lastModified,
      thumbnailImage,
      priceSettings: {
        defaultSalePrice,
        cost,
        defaultRrp,
        localPrices,
      },
      salesChannelAvailableQuantity:
        generateSalesChannelAvailableQuantity(salesChannelQuotas),
      advancedPriceSettings: advancedPriceSettings,
      productInfo: { name, remarks, codes, description, brand, sku },
      tags: { tags },
      stock: {
        stockAvailable,
        stockAvailableUnlimited,
        stockQuantity,
        stockSold,
      },
      productDenominations,
      serviceDetails,
      serviceDetailsOrder,
      status,
      salesChannelUsageUuids,
      hasBeenSold,
      // productGiftCardSetting,
      ...reduxUpdatedStatusControl,
    };
    return _r;
  } else {
    const advancedPriceSettings = buildGroupedPriceSettings(priceTiers);
    return { advancedPriceSettings };
  }
};

const convertDataFromServerToRedux = (data) => {
  const {
    linkedSalesChannels = [],
    product,
    brands,
    taxRules = [],
    currencies,
    salesChannels,
    priceTiers,
  } = data;

  const _product = convertProductFromServerToRedux(
    product.uuid ? product : null,
    priceTiers,
  );

  const _r = {
    ...reduxUpdatedStatusControl,
    ..._product,
    collapseOpen,
    linkedSalesChannels: (linkedSalesChannels || []).map((i) => ({
      uuid: i.uuid,
      name: i.name,
      type: i.channelType,
    })),

    brands,
    taxRules,
    currencies,
    salesChannels: salesChannels.map((i) => i.uuid),
    allSalesChannels: salesChannels || [],
    priceTiers,
  };

  return _r;
};

export {
  getProductName,
  validation,
  convertDataFromServerToRedux,
  convertDataFromReduxToServer,
  convertProductFromServerToRedux,
};
